import { schema } from 'normalizr'

const restaurantImage = new schema.Entity('restaurantImages')

export default restaurantImage
